
import { Component, effect, input, output, ChangeDetectionStrategy } from '@angular/core';
import { ImageCropperComponent, ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { CustomerBranding } from '../../models/customerBranding';

@Component({
  standalone:true,
  imports: [ImageCropperComponent],
  selector: 'app-brand-image-cropper',
  templateUrl: './brand-image-cropper.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./brand-image-cropper.component.scss']
})
export class BrandImageCropperComponent {
  readonly onImageCropped = output<any>();
  readonly isValidImage = output<boolean>();
  readonly isNewBrand = input<boolean>(false);
  readonly brand = input<CustomerBranding | undefined>(undefined);

  public newBrand:boolean = false;
  public existingImage?:string;
  public imageChangedEvent: any;
  public croppedImage: any;
  public showCropper = false;

  constructor() {
    effect(() => {
      this.newBrand = this.isNewBrand();
    });
  }

  //emit event anytime image file is changed
  fileChangeEvent(event: Event) {
    this.imageChangedEvent = event;
    this.newBrand = true;
    this.onImageCropped.emit(undefined)
  }

  //create a new image when cropping occurs
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.blob;
    this.onImageCropped.emit(this.croppedImage);
  }

  //LoadedImage
  imageLoaded(image: LoadedImage) {
    this.showCropper = true;
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    console.log("loading image failed");
  }

  public onCancel() {
    this.croppedImage = undefined;
    this.newBrand=false;
  }
}
